"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadMoreButton = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const shared_styles_1 = require("@/stylesheets/shared.styles");
/**
 * 인라인 "더 보기 / 접기" 토글 버튼.
 * 고정 크기 없이 주변 텍스트에 녹아든다.
 */
let ReadMoreButton = class ReadMoreButton extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.ariaExpanded = 'false';
        this.ariaControls = null;
        this.moreLabel = '더 보기';
    }
    render() {
        return (0, lit_1.html) `
      <button
        type="button"
        aria-expanded=${this.ariaExpanded}
        aria-controls=${this.ariaControls ?? lit_1.nothing}
      >
        <slot>${this.ariaExpanded === 'true' ? '접기' : this.moreLabel}</slot>
      </button>
    `;
    }
};
ReadMoreButton.styles = [
    shared_styles_1.resetStyles,
    (0, lit_1.css) `
      :host {
        display: inline;
      }

      button {
        display: inline;
        border-radius: var(--radius);
        font-weight: var(--font-weight-bold);
        color: var(--foreground-color);

        &:focus-visible {
          ${shared_styles_1.focusRingStyles};
        }
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-expanded' })
], ReadMoreButton.prototype, "ariaExpanded", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-controls' })
], ReadMoreButton.prototype, "ariaControls", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'more-label' })
], ReadMoreButton.prototype, "moreLabel", void 0);
ReadMoreButton = __decorate([
    (0, decorators_js_1.customElement)('mm-read-more-button')
], ReadMoreButton);
exports.ReadMoreButton = ReadMoreButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVhZC1tb3JlLWJ1dHRvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInJlYWQtbW9yZS1idXR0b24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQW9EO0FBQ3BELHFEQUEyRDtBQUkzRCwrREFBMEU7QUFFMUU7OztHQUdHO0FBRUksSUFBTSxjQUFjLEdBQXBCLE1BQU0sY0FBZSxTQUFRLGdCQUFVO0lBQXZDOztRQW9CbUQsaUJBQVksR0FBZ0IsT0FBTyxDQUFBO1FBQ25DLGlCQUFZLEdBQWMsSUFBSSxDQUFBO1FBQ2pDLGNBQVMsR0FBRyxNQUFNLENBQUE7SUFhekUsQ0FBQztJQVhDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7d0JBR1MsSUFBSSxDQUFDLFlBQVk7d0JBQ2pCLElBQUksQ0FBQyxZQUFZLElBQUksYUFBTzs7Z0JBRXBDLElBQUksQ0FBQyxZQUFZLEtBQUssTUFBTSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxTQUFTOztLQUUvRCxDQUFBO0lBQ0gsQ0FBQzs7QUFqQ00scUJBQU0sR0FBRztJQUNkLDJCQUFXO0lBQ1gsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7OztZQVlLLCtCQUFlOzs7S0FHdEI7Q0FDRixDQUFBO0FBQ3VEO0lBQXZELElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsU0FBUyxFQUFFLGVBQWUsRUFBRSxDQUFDO29EQUFvQztBQUNuQztJQUF2RCxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxlQUFlLEVBQUUsQ0FBQztvREFBK0I7QUFDakM7SUFBcEQsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxTQUFTLEVBQUUsWUFBWSxFQUFFLENBQUM7aURBQW1CO0FBdEI1RCxjQUFjO0lBRDFCLElBQUEsNkJBQWEsRUFBQyxxQkFBcUIsQ0FBQztHQUN4QixjQUFjLENBbUMxQjtBQW5DWSx3Q0FBYyJ9